import { MessageCircle } from "lucide-react";
import { RoiCalculator } from "@/components/home/RoiCalculator";
import { PlanCard } from "@/components/pricing/PlanCard";
import { TextLink } from "@/components/ui/Button";
import { FreeAuditButton } from "@/components/ui/Cta";
import { SectionHeader } from "@/components/ui/SectionHeader";
import { useContent } from "@/data/content";
import { usePricing } from "@/data/pricing";

export function PlansSection() {
  const { plans } = useContent().home;
  const pricing = usePricing();

  return (
    <section id="planes" aria-labelledby="plans-heading" className="relative overflow-hidden bg-white">
      <div aria-hidden="true" className="light-pool absolute inset-0 [--pool-x:50%] [--pool-y:0%]" />
      <div className="relative mx-auto max-w-7xl px-4 py-24 sm:px-6 md:py-32 lg:px-8">
        <SectionHeader id="plans-heading" align="center" title={plans.title} lead={plans.subtitle} />

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:items-stretch lg:gap-5">
          {pricing.packs.map((pack, i) => (
            <PlanCard
              key={pack.id}
              pack={pack}
              pricing={pricing}
              postsLabel={plans.postsLabel}
              foundationLabel={plans.foundationLabel}
              delay={i * 80}
            />
          ))}
        </div>

        <p className="mt-8 text-center text-sm text-ink-muted">
          {pricing.taxNote} {pricing.networkNote}
        </p>

        <RoiCalculator />

        <div
          data-reveal=""
          className="mx-auto mt-14 flex max-w-4xl flex-col items-start gap-6 rounded-[1.75rem] bg-teal-soft p-7 sm:p-9 md:flex-row md:items-center md:justify-between"
        >
          <div className="flex gap-4">
            <MessageCircle aria-hidden="true" className="mt-1 size-6 shrink-0 text-teal-strong" />
            <div>
              <h3 className="font-display text-xl font-semibold text-brand-primary sm:text-2xl">{pricing.firstStep.title}</h3>
              <p className="mt-2 max-w-xl leading-relaxed text-ink-soft">{pricing.firstStep.body}</p>
            </div>
          </div>
          <FreeAuditButton location="plans" variant="primary" className="shrink-0" />
        </div>

        <div className="mt-10 text-center">
          <TextLink to="/precios">{plans.cta}</TextLink>
        </div>
      </div>
    </section>
  );
}
